import '..';
import '../js/recaptcha';



// WEBPACK FOOTER //
// ./frontend/entries/registration.js